import { fbt } from 'fbtee'
import { Filter, User } from 'lucide-react'
import { OptionChip } from '../../components/OptionChip'

// Home's floating filter between everyone's plans (the default) and just the
// viewer's. Same chip as the schedule FABs; `peeking` grows its label on arrival
// so it reads as the filter it is before anyone taps it.
export function CrewPlansFab({ withCrew, onToggle, peeking }: { withCrew: boolean; onToggle: () => void; peeking: boolean }) {
  const label = withCrew
    ? fbt('Filter', "Home filter chip label while the calendar and agenda include friends' and groups' plans")
    : fbt('My plans', "Home filter chip label while the calendar and agenda show only the user's own plans")
  const title = withCrew
    ? fbt("Showing your crew's plans too. Tap to show only yours.", 'Tooltip on the Home crew filter chip while crew plans are shown')
    : fbt("Showing only your plans. Tap to add your crew's.", 'Tooltip on the Home crew filter chip while only own plans are shown')

  return (
    <OptionChip
      testId="home-crew-fab"
      icon={withCrew ? <Filter className="size-5" /> : <User className="size-5" />}
      label={label}
      title={title}
      active={!withCrew}
      showLabel={peeking}
      onClick={onToggle}
    />
  )
}
